import { User } from './User';
import { Bus } from './Bus';
import { Closure } from './Closure';
import { Currency } from './Currency';
import { PaymentProcess } from './PaymentProcess';
import { TreasuryDocItem } from './TreasuryDocItem';
import { Mrt } from './Mrt';

export class TreasuryLogDoc {
  id: number;
  amount: number;
  amountInDomesticCurrency: number;
  bus: Bus;
  cancellation: boolean;
  closure: Closure;
  currency: Currency;
  longDescription: string;
  mrt: Mrt;
  paymentMethod: string;
  paymentProcess: PaymentProcess;
  shortDescription: string;
  treasuryDocItem: TreasuryDocItem;
  user: User;

  get currencyName() {
    return this.currency ? this.currency.name : '-';
  }

  get treasuryDocItemConto() {
    return this.treasuryDocItem ? this.treasuryDocItem.conto : '-';
  }

  get paymentProcessCode() {
    return this.paymentProcess ? this.paymentProcess.code : '-';
  }

  get mrtName() {
    return this.mrt ? this.mrt.name : '-';
  }

  get userName() {
    return this.user ? (this.user.firstName + ' ' + this.user.lastName) : '-';
  }

  constructor(data?: any) {
    if (data) {
      Object.assign(this, data);
      this.bus = data.bus ? new Bus(data.bus) : null;
      this.closure = data.closure ? new Closure(data.closure) : null;
      this.currency = data.currency ? new Currency(data.currency) : null;
      this.paymentProcess = data.paymentProcess ? new PaymentProcess(data.paymentProcess) : null;
      this.treasuryDocItem = data.treasuryDocItem ? new TreasuryDocItem(data.treasuryDocItem) : null;
      this.user = data.user ? new User(data.user) : null;
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/model/TreasuryLogDoc.ts